<div class="product-spec container pt-3  pt-md-1 pb-4">
  <p class="overview-title">SPECIFICATION</p>
  <div class="table-wrapper" *ngFor="let spec of specificationsdata">
    <div class="spec-heading" [innerHTML]="spec.heading"></div>
    <table class="table custom-table">
      <tbody>
        <tr class="custom-row" *ngFor="let row of spec.rows">
          <td class="custom-td spec-left fw-bold">
            {{ row.left }}<span *ngIf="row.right"> :</span>
          </td>
          <td class="custom-td spec-right">
            {{ row.right }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>